import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from 'vue';

import { DataTable, DataTableProps } from '@warrenbrasil/nebraska-web';
import { columns } from './columns';
import {
  getAppliedAllocation,
  IAppliedItems
} from '@/modules/wealth/services/portfolio-allocation';

interface Props {
  appliedTable: IAppliedItems[];
  portfolioId: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'AppliedTable',
  props: {
    appliedTable: null,
    portfolioId: null
  },
  setup(__props: any) {

const { appliedTable, portfolioId } = __props as {
  appliedTable: IAppliedItems[];
  portfolioId: string;
};



const tableData = ref(appliedTable);
const isLoading = ref(false);

const productsLength = computed(() => {
  return appliedTable.length;
});

const columnsTable = computed(() => {
  return columns(productsLength.value);
});

const tableStatus = computed(() => {
  return isLoading.value
    ? DataTableProps.DataTableStatus.Loading
    : DataTableProps.DataTableStatus.Default;
});

async function sortTable(index: number, isSort: boolean, value: string) {
  isLoading.value = true;

  try {
    const direction = isSort ? 'Ascending' : 'Descending';
    const orderBy = index === -1 ? undefined : value;
    const orderType = index === -1 ? undefined : direction;

    const params = { orderBy, orderType };

    const data = await getAppliedAllocation(portfolioId, params);

    tableData.value = data.items;
  } finally {
    isLoading.value = false;
  }
}

return { __sfc: true,tableData, isLoading, productsLength, columnsTable, tableStatus, sortTable, DataTable }
}

})